module.exports = __webpack_public_path__ + "a1a8816f11ee9f01fdbc31ae753c3895.png";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/keyart_blocker_frame_bottom_pattern.png
// module id = 445
// module chunks = 0